import React from 'react';
import { Outlet, RouteObject } from 'react-router';
import { CompanyProvider } from '@/Context/CompanyContext';
import AccountSettingsPage from '@/Pages/AccountSettings/AccountSettingsPage';
import CreateRecruitmentPage from '@/Pages/Assessments/Modify/Create/CreateRecruitmentPage';
import EditRecruitmentPage from '@/Pages/Assessments/Modify/Edit/EditRecruitmentPage';
import AssessmentsOverviewPage from '@/Pages/Assessments/Overview/AssessmentsOverviewPage';
import InviteCandidatesPage from '@/Pages/Candidates/Invite/InviteCandidatesPage';
import CandidatesOverviewPage from '@/Pages/Candidates/Overview/CandidatesOverviewPage';
import CandidateResultsPage from '@/Pages/Candidates/Results/CandidateResultsPage';
import RoutePath from './RoutePath';
import DesktopOnlyRoutes from './DesktopOnlyRoutes';
import ClientsOverviewPage from '@/Pages/ClientsOverviewPage/ClientsOverviewPage';
import IdentifiedAiSearchPage from '@/Pages/Candidates/AiSearch/IdentifiedAiSearchPage';
import ShortlistedAiSearchPage from '@/Pages/Candidates/AiSearch/ShortlistedAiSearchPage';
import AgenticSearchPage from '@/Pages/Candidates/AgenticSearch/AgenticSearchPage';

export const companyRouter: RouteObject[] = [
    {
        index: true,
        element: <ClientsOverviewPage />,
    },
    {
        element: <DesktopOnlyRoutes />,
        children: [
            {
                path: RoutePath.AssessmentsActive,
                element: <AssessmentsOverviewPage />,
            },
            {
                path: RoutePath.AgenticAiSearch,
                element: <AgenticSearchPage />,
            },
            {
                path: RoutePath.IdentifiedAiSearch,
                element: <IdentifiedAiSearchPage />,
            },
            {
                path: RoutePath.ShortlistedAiSearch,
                element: <ShortlistedAiSearchPage />,
            },
            {
                path: RoutePath.CandidatesOverview,
                element: <CandidatesOverviewPage />,
            },
            {
                path: RoutePath.CandidateResult,
                element: <CandidateResultsPage />,
            },
            {
                path: RoutePath.CreateAssessment,
                element: <CreateRecruitmentPage />,
            },
            {
                path: RoutePath.EditRecruitment,
                element: <EditRecruitmentPage />,
            },
            {
                path: RoutePath.AttractApplicantsInvite,
                element: <InviteCandidatesPage />,
            },
            ...[
                RoutePath.AccountSettingsGeneral,
                RoutePath.AccountSettingsNotifications,
                RoutePath.AccountSettingsPayment,
                RoutePath.AccountSettingsEmailTemplates,
                RoutePath.AccountSettingsCompanyProfile,
                RoutePath.AccountSettingsTeamMembers,
                RoutePath.AccountSettingsIntegrations,
            ].map((path) => ({ path, element: <AccountSettingsPage /> })),
        ],
    },
];

const CompanyRoutesContextsProvider = () => (
    <CompanyProvider>
        <Outlet />
    </CompanyProvider>
);

export default CompanyRoutesContextsProvider;
